import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgClass, NgIf } from '@angular/common';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { environment, environmentAsync } from 'src/environments/environment.prod';
import { Router } from '@angular/router';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { BrowserService } from 'src/_lib/service/browser.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-shop-by-vehicle',
  templateUrl: './shop-by-vehicle.component.html',
  styleUrls: ['./shop-by-vehicle.component.scss','./shop-by-vehicle-ch2.component.scss','./shop-by-vehicle-ch3.component.scss'],
  standalone: true,
  imports: [NgIf,NgClass]
})
export class ShopByVehicleComponent implements OnInit {
 vehicleName: string = '';
  commonImagePath: string = environment.commonImagePath;
  shop_by_vehicle_name: string = environment.shop_by_vehicle_name;
  chTheme1 = environment.chTheme1;
  chTheme3 = environment.chTheme3;
  chTheme2 = environment.chTheme2;
  chTheme4 = environment.chTheme4;
  chTheme6 = environment.chTheme6;
  chTheme7 = environment.chTheme7;
  chTheme8 = environment.chTheme8;
  chTheme9 = environment.chTheme9;
  chTheme10 = environment.chTheme10;
  chTheme12 = environment.chTheme12;
  chTheme13 = environment.chTheme13;
  chTheme14 = environment.chTheme14;
  chTheme15 = environment.chTheme15;


  isWishlist: boolean = false;

  constructor(
    public dialog: MatDialog,
    private comm: CommunicationService,
    private router: Router,
    private browser: BrowserService,
    private searchByVehicleService:SearchByVehicleService,
    private dynamicThemeClassService: DynamicThemeClassService,
    
  ) { }
    themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }  

  ngOnInit() {
    this.getWishItems();
    this.comm.vehiclenameSubject.subscribe(
      {
    next: (name) => {
          this.vehicleName = name;
    },
    error: (error: Error) => {
          this.vehicleName = '';
          console.error('Custom Error: Unexpected Error while subscribing to vehicle Name', error);
    },
  });
  }

  openVechicleSearchPopup(): void {
    if (!this.vehicleName) {
      this.dialog.open(SearchByVehicleComponent, {
        width: '600px',
        panelClass: 'search-by-vehicle-dialog'
      });
    } else {
      if (this.chTheme1) {
        this.router.navigate(['/parts-and-accessories']);
      } else {
        this.router.navigate(['/categories']);
      }
    }
  }

  
  getWishItems(): void {
    const wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    if (wishItems > 0) {
      this.isWishlist = true;
    } else {
      this.isWishlist = false;
    }
    this.comm.wishlistCount.subscribe(() => {
      const wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
      if (wishItems > 0) {
        this.isWishlist = true;
      } else {
        this.isWishlist = false;
      }
    });
  }

clearVehicle(event: MouseEvent) {
    event.stopPropagation();
    this.searchByVehicleService.clearVehicleSearch();
    this.comm.clearvehicle.next(true);
  }
}